module.exports = __webpack_public_path__ + "fonts/opensans-semibolditalic-webfont.6cb33156.eot";